module.exports = __webpack_public_path__ + "img/14.0d693ebb.png";